export function parseFilterString(value = '') {
  const keyMap = {
    employees: 'employee_id',
    location: 'location_id',
    branch: 'branch_id',
    department: 'department_id',
    request_status: 'status',
    delegator: 'delegator_id',
    from: 'date_from',
    to: 'date_to',
  };

  return String(value).split(';').reduce((result, part) => {
    const separator = part.indexOf('_|');
    if (separator < 0) return result;
    const key = part.slice(0, separator);
    const filterValue = part.slice(separator + 2);
    if (filterValue) result[keyMap[key] || key] = filterValue;
    return result;
  }, {});
}
